import { render, staticRenderFns } from "./juju.vue?vue&type=template&id=10bde518&scoped=true&"
import script from "./juju.vue?vue&type=script&lang=js&"
export * from "./juju.vue?vue&type=script&lang=js&"
import style0 from "./juju.vue?vue&type=style&index=0&id=10bde518&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bde518",
  null
  
)

export default component.exports